import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import ProductList from "@/pages/ProductList";
import ProductDetail from "@/pages/ProductDetail";
import Categories from "@/pages/Categories";
import AdminLogin from "@/pages/AdminLogin";
import NotFound from "@/pages/NotFound";
import AdminLayout from "@/pages/admin/AdminLayout";
import DashboardHome from "@/pages/admin/DashboardHome";
import AdminProducts from "@/pages/admin/Products";
import AdminCategories from "@/pages/admin/Categories";
import AdminBanners from "@/pages/admin/Banners";
import AdminVisual from "@/pages/admin/Visual";
import AdminLeads from "@/pages/admin/Leads";
import AdminMetrics from "@/pages/admin/Metrics";

const Public = ({ children }) => <Layout>{children}</Layout>;

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Public><Home /></Public>} />
                    <Route path="/produtos" element={<Public><ProductList /></Public>} />
                    <Route path="/produtos/:slug" element={<Public><ProductDetail /></Public>} />
                    <Route path="/categorias" element={<Public><Categories /></Public>} />
                    <Route path="/admin/login" element={<AdminLogin />} />
                    <Route path="/admin" element={<AdminLayout />}>
                        <Route index element={<DashboardHome />} />
                        <Route path="produtos" element={<AdminProducts />} />
                        <Route path="categorias" element={<AdminCategories />} />
                        <Route path="banners" element={<AdminBanners />} />
                        <Route path="visual" element={<AdminVisual />} />
                        <Route path="leads" element={<AdminLeads />} />
                        <Route path="metricas" element={<AdminMetrics />} />
                    </Route>
                    <Route path="*" element={<Public><NotFound /></Public>} />
                </Routes>
            </BrowserRouter>
            <Toaster position="top-right" richColors closeButton />
        </div>
    );
}

export default App;
